import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../../auth.store';
import { EntitlementStore } from '../../domain/entitlement/entitlement-store';
import { OrganizationStore } from '../../domain/organization/organization-store';
import { tryBrandSlug } from '../../domain/shared/brand-slug';

/**
 * Keeps /portal/:brandId to the brands the current org is entitled to (its own,
 * its competitors and any other allowed bucket). A super-admin may open any
 * brand. Anything else lands on the portal home instead of a page built from
 * whatever slug was typed into the URL.
 */
export const brandAccessGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const orgStore = inject(OrganizationStore);
  const entitlementStore = inject(EntitlementStore);

  await authStore.loadAuthState();
  await orgStore.settled();
  if (orgStore.isSuperAdmin()) return true;

  await entitlementStore.settled();
  const slug = tryBrandSlug(route.paramMap.get('brandId') ?? '');
  if (slug && entitlementStore.brandAccess().canViewBrand(slug)) return true;
  return router.createUrlTree(['/portal']);
};
